import * as React from 'react';
import {useRef, useState} from 'react';
import {FormattedMessage} from 'react-intl';

import {SortBy} from 'features/search/filters/enums';
import {useOutsideClick} from 'components/hooks/useOutsideClick';
import {getFormattedMessage} from 'features/services/utils/language-helper';
import { useDeviceStore, selectIsMobile } from 'features/ui/store/useDeviceStore';

import './style.scss';

import {Button, ButtonColor, ButtonSize, ButtonType} from 'components/atoms/LinksAndButtons/Button';

interface Props {
    currentSorting: SortBy;
    onSortChange: (sortBy: SortBy) => void;
    showRecommendedSort?: boolean;
    hideAccessSort?: boolean;
    hideGeoLocationButton?: boolean;
}

export const SortController: React.FunctionComponent<Props> = ({
    currentSorting, onSortChange, showRecommendedSort, hideAccessSort, hideGeoLocationButton: _hideGeoLocationButton
}) => {
    const isMobile = useDeviceStore(selectIsMobile);
    const [sortMenuOpen, setSortMenuOpen] = useState<boolean>(false);
    const sortMenuRef = useRef<HTMLDivElement | null>(null);
    const buttonRef = useRef<HTMLButtonElement | null>(null);

    const onSortClick = () => {
        setSortMenuOpen((prev) => !prev); // Toggle menu
    };

    const closeSortMenu = () => {
        setSortMenuOpen(false);
    };

    const itemClick = (itemKey) => {
        console.log(itemKey);
        setSortMenuOpen(false);
        onSortChange(itemKey);
    }

    useOutsideClick({
        refs: [sortMenuRef],
        callback: closeSortMenu,
        excludeRefs: [buttonRef], // Ignore clicks on the button
    });

    const items = [
        {key: SortBy.PRICE_ASC, value: getFormattedMessage('jm.components.SearchResultControlls.priceAsc') },
        {key: SortBy.PRICE_DESC, value: getFormattedMessage('jm.components.SearchResultControlls.priceDesc') },
    ];

    if(!hideAccessSort) {
        items.unshift(
            {key: SortBy.ACCESS_ASC, value: getFormattedMessage('jm.components.SearchResultControlls.accessAsc')},
            //{key: SortBy.ACCESS_DESC, value: getFormattedMessage('jm.components.SearchResultControlls.accessDesc')}
        );
    }

    if(showRecommendedSort) {
        items.unshift({key: SortBy.RECOMENDED, value: getFormattedMessage('jm.components.SearchResultControlls.recommended')});
    }

    const getButtonLabel = () => {
        switch (currentSorting) {
            case SortBy.PRICE_ASC:
                return getFormattedMessage('jm.components.SearchResultControlls.priceAsc');
            case SortBy.PRICE_DESC:
                return getFormattedMessage('jm.components.SearchResultControlls.priceDesc');
            case SortBy.ACCESS_ASC:
                return getFormattedMessage('jm.components.SearchResultControlls.accessAsc');
            case SortBy.ACCESS_DESC:
                return getFormattedMessage('jm.components.SearchResultControlls.accessDesc');
            case SortBy.RECOMENDED:
                return getFormattedMessage('jm.components.SearchResultControlls.recommended');
            default:
                return getFormattedMessage('jm.components.SearchResultControlls.sort');
        }
    } 

    return (
        <>
            <Button 
                onClick={onSortClick} 
                className={`${sortMenuOpen ? 'button--active' : ''}`} 
                ref={buttonRef} 
                buttonColor={ButtonColor.DEFAULT} 
                buttonSize={ButtonSize.DEFAULT} 
                buttonType={ButtonType.FOLD} 
            >
                {isMobile
                    ? <FormattedMessage id="jm.components.SearchResultControlls.sort" />
                    : getButtonLabel()
                }
            </Button>


            {sortMenuOpen &&
                <div 
                    className="search-result-controlls__sort-menu" 
                    ref={sortMenuRef}
                >
                    <ul>
                        {items.map(item => (
                            <li>
                                <Button 
                                    buttonColor={ButtonColor.DEFAULT} 
                                    buttonSize={ButtonSize.FULL} 
                                    buttonType={ButtonType.NO_STYLE} 
                                    onClick={() => itemClick(item.key)} 
                                    key={item.key}
                                >
                                    {item.value}
                                </Button>
                            </li>
                        ))}
                    </ul>
                </div>
            }
        </>
    );
};
